import {
  ArticleHeading1,
  ArticleHeading4,
  FormField,
  LinkButton,
  MaskedInput,
  TDeviceType,
  UIText3,
} from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import * as styles from './HighReward.css';
import { TYPOGRAPHY } from './constants';
import { Section } from '../Section';

interface IHighRewardProps {
  deviceType: TDeviceType;
  apartmentPrice: string;
  percentageReward: string;
  rewardTariffsUrl: string;
  onChangeApartmentPrice: (value: string) => void;
  onChangePercentageReward: (value: string) => void;
  reward: string;
}

export const HighReward: React.FC<IHighRewardProps> = ({
  deviceType,
  reward,
  apartmentPrice,
  percentageReward,
  rewardTariffsUrl,
  onChangeApartmentPrice,
  onChangePercentageReward,
}) => {
  const AdaptiveHeading = deviceType === 'phone' ? ArticleHeading4 : ArticleHeading1;

  return (
    <Section deviceType={deviceType}>
      <div className={cn(styles['container'], styles[`container-${deviceType}`])}>
        <div className={styles[`container-body-${deviceType}`]}>
          <div className={cn(styles['reward'], styles[`reward-${deviceType}`])} data-testid="Reward">
            <div
              className={cn(styles['reward-banner'], styles[`reward-banner-${deviceType}`])}
              data-testid="reward-banner"
            ></div>
            <div className={cn(styles['reward-container'], styles[`reward-container-${deviceType}`])}>
              <h3 className={cn(styles['reward-title'], styles[`reward-title-${deviceType}`])}>
                {TYPOGRAPHY.REWARD_TITLE[deviceType]}
              </h3>
              <LinkButton href={rewardTariffsUrl} theme="stroke_white_secondary">
                Процент вознаграждения
              </LinkButton>
            </div>
          </div>
          <article
            className={cn(styles['calculator'], styles[`calculator-${deviceType}`])}
            data-testid="CalculatorReward"
          >
            <div className={cn(styles['calculator-container'], styles[`calculator-container-${deviceType}`])}>
              <AdaptiveHeading color="black_100" fontWeight="bold">
                {TYPOGRAPHY.CALCULATOR_TITLE}
              </AdaptiveHeading>
              <form noValidate className={styles[`calculator-form-${deviceType}`]}>
                <FormField withoutMargin label="Стоимость квартиры">
                  <MaskedInput
                    size="M"
                    mask="num"
                    data-testid="apartmentPrice"
                    value={apartmentPrice}
                    onChange={onChangeApartmentPrice}
                    lazy
                    blocks={{
                      num: {
                        /* Неправильно определен тип в ките
                       eslint-disable-next-line @typescript-eslint/ban-ts-comment
                       @ts-ignore */
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: ' ',
                      },
                    }}
                    placeholder="25 000 000"
                    color="black_100"
                    rightAdornment={<span className={styles['form-input-symbol']}>₽</span>}
                  />
                </FormField>
                <FormField withoutMargin label="Процент вознаграждения">
                  <MaskedInput
                    size="M"
                    mask="num"
                    data-testid="percentageReward"
                    value={percentageReward}
                    onChange={onChangePercentageReward}
                    onKeyDown={event => {
                      if ((event.key === ',' || event.key === '.' || event.key === ' ') && percentageReward === '100') {
                        event.preventDefault();
                      }
                    }}
                    lazy
                    blocks={{
                      num: {
                        /* Неправильно определен тип в ките
                       eslint-disable-next-line @typescript-eslint/ban-ts-comment
                       @ts-ignore */
                        mask: Number,
                        scale: 1,
                        min: 0,
                        max: 100,
                        radix: ',',
                        mapToRadix: [' ', '.'],
                      },
                    }}
                    color="black_100"
                    placeholder="4,0"
                    rightAdornment={<span className={styles['form-input-symbol']}>%</span>}
                  />
                </FormField>
              </form>
              <div className={styles['calculator-reward']}>
                <ArticleHeading4 color="black_100" fontWeight="400">
                  Ваше вознаграждение
                </ArticleHeading4>
                <p className={styles['calculator-reward-text']} data-testid="calculator-reward">
                  {reward} <span className={styles['calculator-reward-symbol']}>₽</span>
                </p>
                <UIText3 color="black_100">до вычета налога</UIText3>
              </div>
            </div>
          </article>
        </div>
      </div>
    </Section>
  );
};
